import { ENDPOINT } from "../../constants/server/api";
import { fetchApiData } from "../../utils/apiUtils";

export const getMemberGroupPagination =
  (businessSlug, params) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.MEMBER_GROUP}/pagination/list`,
      params: {
        business_slug: businessSlug,
        ...params,
      },
      dispatch,
    });
    return data;
  };

export const getMemberGroupExcel =
  (businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.MEMBER_GROUP}/excel`,
        params: {
          business_slug: businessSlug,
          ...params,
        },
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "member_groups.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const getAllMemberGroups = (businessSlug) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MEMBER_GROUP}/all/${businessSlug}/list`,
    dispatch,
  });
  return data;
};

export const deleteMemberGroup = (id) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "delete",
      endpoint: `${ENDPOINT.MEMBER_GROUP}/${id}`,
      dispatch,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getMemberGroupById = (id) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.MEMBER_GROUP}/${id}`,
      dispatch,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateMemberGroup = (id, requestBody) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.MEMBER_GROUP}/${id}`,
      data: requestBody,
      dispatch,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const createMemberGroup = (requestBody) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.MEMBER_GROUP}`,
      data: requestBody,
      dispatch,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const removeMemberFromGroup =
  (memberGroupId, businessSlug, requestBody) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "delete",
        endpoint: `${ENDPOINT.MEMBER_GROUP}/${memberGroupId}/members/remove`,
        params: {
          business_slug: businessSlug,
        },
        data: requestBody,
        dispatch,
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  };

export const getMemberGroupMembersPagination =
  (memberGroupId, businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "get",
        endpoint: `${ENDPOINT.MEMBER_GROUP}/${memberGroupId}/members/pagination`,
        params: {
          business_slug: businessSlug,
          ...params,
        },
        dispatch,
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  };

export const getMemberGroupMembersExcel =
  (memberGroupId, businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.MEMBER_GROUP}/${memberGroupId}/members/excel`,
        params: {
          business_slug: businessSlug,
          ...params,
        },
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "group_members.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const getMemberHistoryPagination =
  (businessSlug, params) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.MEMBER}/history/pagination/list`,
      params: {
        businessSlug,
        ...params,
      },
      dispatch,
    });
    return data;
  };

export const getMemberHistoryExcel =
  (businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.MEMBER}/history/excel`,
        params: {
          businessSlug,
          ...params,
        },
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "member_history.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const getMemberHistoryDebtorPaymentPagination =
  (businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "get",
        endpoint: `${ENDPOINT.MEMBER}/history/pagination/debtor-payment`,
        params: {
          businessSlug,
          ...params,
        },
        dispatch,
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  };

export const getMemberHistoryDebtorPaymentExcel =
  (businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.MEMBER}/history/excel/debtor-payment`,
        params: {
          businessSlug,
          ...params,
        },
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "รายการบันทึกลูกหนี้.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const getMemberPagination =
  (businessSlug, params) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.MEMBER}/pagination/list`,
      params: {
        businessSlug,
        ...params,
      },
      dispatch,
    });
    return data;
  };

export const getMemberExcel = (businessSlug, params) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.MEMBER}/excel`,
      params: {
        businessSlug,
        ...params,
      },
      responseType: "blob",
      dispatch,
    });
    if (data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "รายชื่อลูกค้า/สมาชิก.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error(error);
  }
};

export const getAllMembers = (businessSlug) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MEMBER}/all/list`,
    params: {
      business_slug: businessSlug,
    },
    dispatch,
  });
  return data;
};

export const deleteMember = (id) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "delete",
      endpoint: `${ENDPOINT.MEMBER}/${id}`,
      dispatch,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateMember =
  (businessSlug, id, requestBody) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "put",
        endpoint: `${ENDPOINT.MEMBER}/${id}`,
        params: {
          businessSlug,
        },
        data: requestBody,
        dispatch,
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  };

export const updateMemberCreditLimit =
  (businessSlug, id, creditLimitAmount) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "put",
        endpoint: `${ENDPOINT.MEMBER}/${id}`,
        params: { businessSlug },
        data: { credit_limit_amount: creditLimitAmount },
        dispatch,
      });
      return data;
    } catch (error) {
      console.error(error);
    }
  };

export const getMemberById = (id) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.MEMBER}/${id}`,
      dispatch,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
